export default {
  path: 'winter-service/v2/irregularities',
  name: 'WinterService2Irregularities',
  component: () => import(/* webpackChunkName: "road-maintenance" */ '../views/IrregularitiesIndex.vue')
}
